import { api } from './api';

export type PlanRowStatus = 'proposed' | 'agreed' | 'done' | 'dropped';

export interface PlanRowView {
  id: string;
  kind: 'decision' | 'action';
  text: string;
  owner?: { id: string | null; name: string | null; role: string | null };
  horizon: 'today' | 'this-week' | 'this-month' | 'later' | 'unspecified';
  status: PlanRowStatus;
  evidenceSeq: number[];
  agreedQuote?: string;
  shadow: boolean;
  updatedAt: string;
}

export interface PlanOfRecordView {
  sessionId: string;
  mode: 'off' | 'shadow' | 'live';
  rows: PlanRowView[];
}

export const planOfRecordService = {
  async get(sessionId: string): Promise<PlanOfRecordView> {
    const res = await api.get(`/api/sessions/${sessionId}/plan-of-record`);
    return res.data;
  },
};

export interface SessionHealthView {
  line: string;
  parts: Record<string, string | number>;
  shadow: boolean;
  seqTo?: number;
  at: string;
}

export const sessionHealthService = {
  async get(sessionId: string): Promise<SessionHealthView | null> {
    const res = await api.get(`/api/sessions/${sessionId}/health-line`);
    return res.data?.health ?? null;
  },
};
